import React from 'react';
import { useSpring, animated } from 'react-spring';
import isVod from '../../../shared/helpers/isVod';
import Poster from './Poster/Poster';
import VodPoster from './VodPoster/VodPoster';

const Posters = ({ films }) => {
  const props = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 1000 },
  });

  const renderPoster = (film) => {
    if (isVod(film)) {
      return <VodPoster vod={film} key={`${film.id}`} />
    }
    return <Poster film={film} key={`${film.id}`} />
  };

  return (
    <animated.div className="program-grid" style={props}>
      {films.map((film) => renderPoster(film))}
    </animated.div>
  );
};

export default Posters;
